import {useMemo} from "react";
import {Box, CircularProgress, useTheme} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import styles from "./ListView.module.css";
import {DEFAULT_PAGE_SIZE_OPTIONS, DEFAULT_PAGINATION} from "../../utils/pagination";

const ListView = ({columns, data = [], topRightButtons, loading, onRowClick, getRowId, dataGridProps = {}}) => {
  const theme = useTheme();

  const rows = useMemo(() => {
    return Array.isArray(data) ? data : data?.data || [];
  }, [data]);

  const flexColumns = useMemo(() => {
    return columns.map((col) => {
      /*if (col.width || col.flex) {
        return col;
      }*/

      if (col.field === "actions") {
        return {
          ...col,
          width: 100,
          align: "center",
          headerAlign: "center"
        };
      }

      return {
        ...col,
        flex: 1,
        minWidth: 150
      };
    });
  }, [columns]);

  return (
    <>
      {loading ? (
        <CircularProgress size={300} color={theme.palette.colors.primary} />
      ) : (
        <Box
          className={styles.container}
          style={{
            backgroundColor: theme.palette.card.background,
            borderRadius: theme.palette.card.borderRadius,
            boxShadow: theme.palette.card.borderShadow,
            border: `1px solid ${theme.palette.card.border}`
          }}
        >
          {topRightButtons && <header className={styles.header}>{topRightButtons}</header>}
          <DataGrid
            rows={rows}
            columns={flexColumns}
            {...dataGridProps}
            className={styles.dataGrid}
            slotProps={{
              pagination: {
                SelectProps: {
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        bgcolor: theme.palette.windowScreen.background,
                        "& .MuiMenuItem-root": {
                          color: theme.palette.text.primary
                        }
                      }
                    }
                  }
                }
              }
            }}
            sx={{
              border: "none",
              borderRadius: theme.palette.card.borderRadius,
              "& .MuiDataGrid-columnHeader": {
                paddingLeft: "20px",
                paddingRight: "20px",
                backgroundColor: theme.palette.listView.headerBackground,
                color: theme.palette.listView.headerText,
                fontWeight: "bold"
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: theme.palette.listView.rowHoverBackground
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none"
              },
              "& .MuiDataGrid-cell": {
                paddingLeft: "20px",
                paddingRight: "20px"
              },

              "& .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiSelect-icon": {
                color: theme.palette.listView.headerText
              },

              "& .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiIconButton-root": {
                color: theme.palette.listView.headerText
              }
            }}
            getRowId={getRowId}
            loading={loading}
            localeText={{
              MuiTablePagination: {
                labelRowsPerPage: "Filas por página:",
                labelDisplayedRows: ({from, to, count}) => `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`
              }
            }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: DEFAULT_PAGINATION
                }
              },
              pinnedColumns: {right: ["actions"]}
            }}
            pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
            disableRowSelectionOnClick
            onRowClick={(params) => {
              if (onRowClick) {
                onRowClick(params.row);
              }
            }}
          />
        </Box>
      )}
    </>
  );
};

export default ListView;
